import { render, staticRenderFns } from "./About_en.vue?vue&type=template&id=3f0f8b40"
import script from "./About_en.vue?vue&type=script&lang=js"
export * from "./About_en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports